import React from 'react';
import get from 'lodash/get';
import LegacyTextRenderer from './LegacyTextRenderer';
import DOMPurify from 'isomorphic-dompurify';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
const ExcerptRenderer = /*#__PURE__*/ React.forwardRef(({ textContent , className , htmlExcerptLegacy , isPollWithHtmlExcerpt , legacyTheme , disableStylesForLegacy , emptyPlaceHolder =''  }, ref)=>{
    const shouldClean = useFlag('legacy_clean');
    if (!textContent) {
        return null;
    }
    const type = get(textContent, 'html.type');
    // not using the default value param because it should fall back for empty string, too
    const excerpt = get(textContent, 'excerpt') || emptyPlaceHolder;
    if (htmlExcerptLegacy && type === 'writer') {
        return /*#__PURE__*/ React.createElement(LegacyTextRenderer, {
            className: className,
            html: excerpt,
            theme: legacyTheme,
            disableStyles: disableStylesForLegacy,
            ref: ref
        });
    }
    if (isPollWithHtmlExcerpt && type === 'draft' && excerpt.trim().length > 0) {
        return /*#__PURE__*/ React.createElement("div", {
            className: className,
            dangerouslySetInnerHTML: {
                __html: shouldClean ? DOMPurify.sanitize(excerpt, {
                    FORCE_BODY: true,
                    ADD_TAGS: [
                        'iframe'
                    ]
                }) : excerpt
            },
            ref: ref
        });
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: className,
        ref: ref
    }, excerpt);
});
ExcerptRenderer.displayName = 'ExcerptRenderer';
export default ExcerptRenderer;
